@if (settings$ | async; as settings) {
  <h4>{{ 'AbpAccount::SocialAccountSecurity' | abpLocalization }}</h4>
  <div class="form-check mb-2">
    <input
      type="checkbox"
      class="form-check-input"
      id="verify-password"
      [(ngModel)]="settings.verifyPasswordDuringExternalLogin"
    />
    <label class="form-check-label" for="verify-password">{{
        'AbpAccount::DisplayName:VerifyPasswordDuringExternalLogin' | abpLocalization
      }}</label>
    <br/>
    <small class="form-text text-muted">{{
        'AbpAccount::Description:VerifyPasswordDuringExternalLogin' | abpLocalization
      }}</small>
  </div>

  <div (keyup.enter)="submit(settings)">
    @for (provider of settings.externalProviders; track $index) {
      @if (isTenant) {
        <h4>{{ provider.name }}</h4>
        <div class="form-check mb-2">
          <input
            type="checkbox"
            class="form-check-input"
            [attr.id]="provider.name + '.use-host-settings'"
            [(ngModel)]="provider.enabled"
          />
          <label class="form-check-label" [for]="provider.name + '.use-host-settings'">{{
              'AbpAccount::ExternalProviderEnabled' | abpLocalization
            }}</label>
        </div>
        @if (provider.enabled) {
          <div class="form-check mb-2">
            <input
              type="checkbox"
              class="form-check-input"
              [attr.id]="provider.name + '.use-custom-settings'"
              [(ngModel)]="provider.useCustomSettings"
            />
            <label class="form-check-label" [for]="provider.name + '.use-custom-settings'">{{
                'AbpAccount::ExternalProviderOverrideHostValue' | abpLocalization
              }}</label>
          </div>

          <div class="collapse" [class.show]="provider.useCustomSettings">
            <ng-container *ngTemplateOutlet="propertySetsTemplate"></ng-container>
          </div>
        }


      } @else {
        <h4>{{ provider.name }}</h4>

        <div class="form-check mb-2">
          <input
            type="checkbox"
            [attr.id]="provider.name + '.enabled'"
            [attr.name]="provider.name + '.enabled'"
            class="form-check-input"
            [(ngModel)]="provider.enabled"
            autofocus
          /><label class="form-check-label" [attr.for]="provider.name + '.enabled'">{{
            'AbpAccount::ExternalProviderEnabledForHost' | abpLocalization
          }}</label>
          <br/>
          <small class="form-text text-muted">{{
              'AbpAccount::ExternalProviderEnabledForHostExplanation' | abpLocalization
            }}</small>
        </div>

        <div class="form-check mb-2">
          <input
            type="checkbox"
            [attr.id]="provider.name + '.enabledForTenantUser'"
            [attr.name]="provider.name + '.enabledForTenantUser'"
            class="form-check-input"
            [(ngModel)]="provider.enabledForTenantUser"
            autofocus
          /><label class="form-check-label" [attr.for]="provider.name + '.enabledForTenantUser'">{{
            'AbpAccount::ExternalProviderEnabledForTenant' | abpLocalization
          }}</label>
          <br/>
          <small class="form-text text-muted">{{
              'AbpAccount::ExternalProviderEnabledForTenantExplanation' | abpLocalization
            }}</small>
        </div>
        @if (provider.enabled) {
          <ng-container *ngTemplateOutlet="propertySetsTemplate"></ng-container>
        }
      }

      <ng-template #propertySetsTemplate>
        <ng-container
          *ngTemplateOutlet="singlePropertySetTemplate; context: { $implicit: provider.properties }"
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            singlePropertySetTemplate;
            context: {
              $implicit: provider.secretProperties,
              type: 'password',
              autocomplete: 'new-password',
            }
          "
        ></ng-container>

        <ng-template
          #singlePropertySetTemplate
          let-properties
          let-type="type"
          let-autocomplete="autocomplete"
        >
          @for (property of properties; track $index) {
            <div class="mb-3">
              <label class="form-label" [attr.for]="provider.name + '.' + property.name">{{
                  '::ExternalProvider:' + provider.name + ':' + property.name | abpLocalization
                }}</label>
              <input
                [type]="type || 'text'"
                [autocomplete]="autocomplete || 'off'"
                class="form-control"
                [(ngModel)]="property.value"
                [attr.id]="provider.name + '.' + property.name"
              />
            </div>
          }
        </ng-template>
      </ng-template>
    }
    <hr/>
    <div>
      <abp-button (click)="submit(settings)" iconClass="fa fa-save" [loading]="loading">{{
          'AbpAccount::Save' | abpLocalization
        }}
      </abp-button>
    </div>
  </div>
}
